<div class="waitlist-page">
  <header class="app-bar">
    @if (view && view.selfServiceEnabled) {
      <app-icon-button (click)="openSettings()" [ariaLabel]="'waitlist.settings.title' | transloco" colorVariant="transparent-white" icon="settings" size="small"/>
    }
  </header>

  <main class="wrapper">
    <app-logo [imageUrl]="view?.appearance?.imageUrl"/>

    @if (notFound) {
      <section class="card message-card">
        <mat-icon class="message-icon">link_off</mat-icon>
        <div class="typo-h1">{{ 'waitlist.notFound.title' | transloco }}</div>
        <div class="body-text">{{ 'waitlist.notFound.message' | transloco }}</div>
      </section>
    } @else if (view) {
      <div class="content">
        <section class="intro">
          <h1 class="hero-title">{{ 'waitlist.intro.title' | transloco }}</h1>

          <div class="keydata">
            <div class="keydata-facts">
              @if (view.patient?.name) {
                <div class="info-line">
                  <mat-icon>physical_therapy</mat-icon>
                  <div class="body-text">
                    <span class="body-text-bold">{{ view.patient!.name }}</span>
                    @if (view.patient!.dateOfBirth) {
                      · {{ 'waitlist.intro.born' | transloco }} {{ view.patient!.dateOfBirth | customDate:'dd.MM.yyyy' }}
                    }
                  </div>
                </div>
              }

              <div class="info-line">
                <mat-icon>clock_loader_10</mat-icon>
                <div class="body-text">
                  <span class="body-text-bold">{{ 'waitlist.intro.waitingSince' | transloco }}</span>
                  · {{ view.waitingSince | customDate:'dd.MM.yyyy' }}
                </div>
              </div>
            </div>

            @if (view.selfServiceEnabled && !isClosed) {
              <app-text-button class="keydata-action" (click)="leaveWaitlist()" [text]="'waitlist.action.leave' | transloco" colorVariant="outlined-cancelled" leadingIcon="logout" type="rounded"/>
            }
          </div>

          @if (!isClosed && view.reservation) {
            <div class="body-text">
              {{ (view.selfServiceEnabled ? 'waitlist.intro.reservation' : 'waitlist.intro.reservationOnly') | transloco }}
            </div>
          }
        </section>

        @if (isClosed) {
          <section class="card message-card">
            <mat-icon class="message-icon">check_circle</mat-icon>
            <div class="body-text">{{ closedMessageKey | transloco }}</div>
          </section>
        } @else {
          @if (view.reservation; as offer) {
            <section class="card">
              <div class="card-header">
                <mat-icon class="card-header-icon">star</mat-icon>
                <div class="card-header-title">{{ 'waitlist.reservation.title' | transloco }}</div>
                <div class="card-header-notice">
                  <mat-icon>schedule</mat-icon>
                  <div class="body-text-small">
                    <span class="body-text-small-bold">{{ timeLeft(offer.expiresAt) }}</span>
                    · {{ 'waitlist.reservation.until' | transloco }} {{ offer.expiresAt | customDate:'dd.MM.yyyy HH:mm' }}
                  </div>
                </div>
              </div>

              <div class="card-content">
                <app-slot-details class="slot-details" [slot]="offer"/>

                <div class="card-actions">
                  <app-text-button (click)="declineReservation()" [text]="'waitlist.action.decline' | transloco" colorVariant="outlined-cancelled" leadingIcon="event_busy" type="rounded"/>
                  <app-text-button (click)="bookReservation(offer)" [text]="'waitlist.action.bookReservation' | transloco" colorVariant="primary" leadingIcon="check" type="rounded"/>
                </div>
              </div>
            </section>
          }

          @if (!view.selfServiceEnabled && !view.reservation) {
            <!-- the practice runs this entry and holds nothing for the patient, e.g. right after a decline -->
            <section class="card message-card">
              <mat-icon class="message-icon">event_busy</mat-icon>
              <div class="body-text">{{ 'waitlist.noReservation' | transloco }}</div>
            </section>
          }

          @if (view.selfServiceEnabled) {
            <section class="slots">
              <h2 class="body-text-bold section-title">
                {{ (view.reservation ? 'waitlist.slots.titleMore' : 'waitlist.slots.title') | transloco }}
              </h2>

              @if (view.slots.length === 0) {
                <div class="card message-card">
                  <mat-icon class="message-icon">event_busy</mat-icon>
                  <div class="body-text">{{ 'waitlist.slots.empty' | transloco }}</div>
                </div>
              } @else {
                @for (slot of view.slots; track slot.employeeId + slot.from) {
                  <div class="card">
                    <div class="card-content">
                      <app-slot-details class="slot-details" [slot]="slot"/>

                      <div class="card-actions">
                        <app-text-button (click)="bookSlot(slot)" [text]="'waitlist.action.book' | transloco" colorVariant="tertiary" leadingIcon="check" type="rounded"/>
                      </div>
                    </div>
                  </div>
                }
              }
            </section>
          }
        }
      </div>
    }
  </main>
</div>
